export default __webpack_public_path__ + "static/media/room-geleia-real-3.9b5d75b0.jpg";